import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const handleEnroll = () => {
    navigate('/apply_now');
  };

  return (
    <Box
      id="footer"
      sx={{
        width: '100%', margin: '10px auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '50px',
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography sx={{
          background: 'linear-gradient(to right, #AE67FA, #F49867)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: { xs: '40px', sm: '50px' }, fontWeight: '600', lineHeight: { xs: '50px', sm: '55px' }, width: { xs: '100%', sm: '60%' }, margin: '10px auto', textAlign: 'center',
        }}
        >
          Coding and creative courses for kids
        </Typography>
        <Button
          onClick={handleEnroll}
          variant="outlined"
          sx={{
            backgroundColor: 'transparent', color: '#fff', border: '1px solid #fff', '&:hover': { border: '1px solid #AE67FA', color: '#AE67FA' }, padding: '8px 35px',
          }}
        >
          Join Us Now
          <KeyboardArrowRightIcon />
        </Button>
      </Box>
      <Box sx={{ width: '100%' }}>
        <hr />
      </Box>
      <Box>
        <Box sx={{
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center',
        }}
        >
          <Typography sx={{ fontSize: '18px', fontWeight: '500' }}>ACCESSIN-CODE</Typography>
          <Typography sx={{ fontSize: '16px', fontWeight: '300' }}>ACCESSIN-CODE &copy; 2022 | ALL RIGHTS RESERVED</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
